//--
import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
 

import { RequestType } from "../../../types/enums/request-enums";
 //#region comment metod
 const GetWalletByCustomerId=(params : any)=>request({
  url: ApiURL.Query.GetWallet+"?CustomerId="+params,
  method: RequestType.GET,
 });

 const GetCustomerIdWithEmail=(params : any)=>request({
  url: ApiURL.Query.GetCustomerIdWithEmail+"/"+params,
  method: RequestType.GET,
 });
 

const LcwMoneyQuery = {
  GetWalletByCustomerId,
  GetCustomerIdWithEmail
};

export default LcwMoneyQuery;
